@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.container {
    display: grid;
    grid-template-columns: 1fr 1fr;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: 1fr;
    }

    & h1 {
        // Override the usual Hero text-transform styling
        text-transform: none;
    }

    & > section {
        // Override the usual Hero fixed height
        height: 600px;
    }
}

.title {
    text-transform: none;
}
